<span style="padding: 15px;"><strong>Collections</strong> | Collections/My List</span>
<mat-tab-group style="height:  calc(100% - 30px);">
    <mat-tab label="My Collection List">
        <app-collection-list></app-collection-list>
    </mat-tab>
    <mat-tab label="My Promise To Pays">
        <app-ptp-collection-list></app-ptp-collection-list>
    </mat-tab>
</mat-tab-group>